"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[9778],{

/***/ 79778:
/***/ ((module) => {

module.exports = JSON.parse('{"miniPackageHeadline":"The Mini package has been added","miniPackageText":"The activation of the Mini package for the company {name} has been completed!","databaseIsArchived":"The database is archived!","databaseIsArchivedText":"Archiving of {name} has been completed!","databaseIsUnarchived":"The database is reactivated!","databaseIsUnarchivedText":"The reactivation of {name} has been completed!","databaseIsDeleted":"The database has been removed!","databaseIsDeletedText":"The removal of {name} has been completed!"}');

/***/ })

}]);